@if (activeIdentity$ | async; as activeIdentity) {
  @if (!!activeIdentity && (isMaintenanceRoute$ | async) === false) {
    <app-new-layout></app-new-layout>
  }
}
<!-- auxiliary outlet targeted by fullscreen security components e.g. sign-in -->
<router-outlet name="top"></router-outlet>
